module.exports = __webpack_public_path__ + "img/logo-dark.fbe7a9bc.png";